var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"signature-box"},[_c('canvas',{attrs:{"id":_vm.id}})]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"red"},on:{"click":_vm.clearSignaturePad}},[_vm._v("\n    Clear\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }